import functions from "./functions.js";
import { animateSuccess, animateRestore } from "./newsletter-animation.js";

$(function () {

    const $form = $('.newsletter-form');
    const form = $form[0];

    const lang = functions.getLang();
    let output = '';

    if (!form) {
        return;
    }

    $form.on('submit', e => {
        e.preventDefault();

        $form.addClass('processing');
        
        let params = {};
        $.each($form.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        params['language'] = functions.getLang();

        grecaptcha.enterprise.ready(function () {
            grecaptcha.enterprise.execute('6Lcund0sAAAAAEIOHzAuUX9qaowZ34zWpKAEnPxp', { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                params['recaptchaType'] = 'enterprise';
                params = functions.getDataForUrl(params);
                $.post('/services/mailchimp/', params).then(response => {
                    
                    response = JSON.parse(response);
                    
                    $form.removeClass('processing');
                    const doneMsg   = $form.find('.done-message').removeClass('d-none').html(response.data)[0];
                    const formInput = $form.find('.form-input').addClass('pe-none')[0];
                    animateSuccess(doneMsg, formInput);

                    setTimeout(() => {
                        const restoreDoneMsg   = $form.find('.done-message')[0];
                        const restoreFormInput = $form.find('.form-input').removeClass('pe-none')[0];
                        animateRestore(restoreDoneMsg, restoreFormInput);
                    }, 5000);

                    if (response.status == true) {
                        if (typeof fbq === 'function') fbq('track', 'Subscribe');
                        form.reset();
                    }
                });
            });
        });
    });
});
